<div class="container-fluid profile-details-new">
    <div class="card">
        <div class="card-body p-4">
            <div class="row align-items-center mb-3">
                <div class="col-md-8">
                    <h4 class="color-primary font-weight-bold mb-0">Student Profile</h4>
                </div>
                <div class="col-md-4 text-md-right">
                    <button class="btn btn-outline-primary" (click)="backFunction()">
                        <i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back
                    </button>
                </div>
            </div>

            <!-- Student summary header -->
            <div class="student-hero-card">
                <div class="hero-avatar">
                    <img [src]="profileAvatar" alt="Student">
                </div>
                <div class="hero-info">
                    <h4 class="hero-name text-capitalize">{{ getStudentFieldValue('first_name') }} {{ getStudentFieldValue('last_name') }}</h4>
                    <div class="hero-meta">
                        <span class="meta-chip"><i class="fa fa-graduation-cap"></i> Grade {{ getStudentFieldValue('grade_name') }}</span>
                        <span class="meta-chip meta-active"><i class="fa fa-check-circle"></i> {{ getStudentFieldValue('status') }}</span>
                        <span class="meta-chip"><i class="fa fa-envelope-o"></i> {{ getStudentFieldValue('email_id') }}</span>
                    </div>
                </div>
                <div class="hero-side d-none d-md-flex">
                    <div class="hero-stat">
                        <span class="stat-label">Student ID</span>
                        <span class="stat-value">{{ getStudentFieldValue('school_idno') }}</span>
                    </div>
                    <div class="hero-stat">
                        <span class="stat-label">Registered</span>
                        <span class="stat-value">{{ getStudentFieldValue('registration_date') }}</span>
                    </div>
                </div>
            </div>

            <!-- Main tabs -->
            <div class="row mt-4">
                <div class="col-12">
                    <ul class="nav nav-tabs profile-main-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'profile'" href="javascript:void(0)"
                               (click)="setTab('profile')">Profile</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'classes'" href="javascript:void(0)"
                               (click)="setTab('classes')">Class Details</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'attendance'" href="javascript:void(0)"
                               (click)="setTab('attendance')">Attendance (Daywise)</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'curriculum'" href="javascript:void(0)"
                               (click)="setTab('curriculum')">Curriculum / Reports</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'communications'" href="javascript:void(0)"
                               (click)="setTab('communications')">Communications</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="tab-content-panel mt-3">
                <!-- Profile: Personal & Parent -->
                <div *ngIf="activeTab === 'profile'">
                    <ul class="nav profile-sub-tabs">
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="profileSubTab === 'personal'" href="javascript:void(0)"
                               (click)="setProfileSubTab('personal')">
                                <i class="fa fa-user-o mr-1"></i> Personal Details
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="profileSubTab === 'parent'" href="javascript:void(0)"
                               (click)="setProfileSubTab('parent')">
                                <i class="fa fa-users mr-1"></i> Parent / Guardian
                            </a>
                        </li>
                    </ul>

                    <!-- Personal -->
                    <div *ngIf="profileSubTab === 'personal'" class="profile-info-panel">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 mb-3" *ngFor="let group of personalInfoGroups; let i = index">
                                <div class="info-group-card">
                                    <div class="info-group-header">
                                        <i class="fa {{ group.icon }}"></i>
                                        <span>{{ group.title }}</span>
                                    </div>
                                    <div class="info-group-body">
                                        <div class="info-field" *ngFor="let field of group.fields">
                                            <span class="field-label">{{ field.label }}</span>
                                            <div class="hero-avatar" *ngIf="i == '2'">
                                                <img [src]="profileAvatar" alt="Student">
                                            </div>
                                            <span *ngIf="i != '2'" class="field-value" [class.text-capitalize]="field.capitalize"
                                                  [class.value-success]="field.highlight === 'success'">
                                                {{ getStudentFieldValue(field.valueKey) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Parent -->
                    <div *ngIf="profileSubTab === 'parent'" class="profile-info-panel">
                        <div class="parent-selector">
                            <button type="button" class="parent-pill" [class.active]="selectedParent === 1"
                                    (click)="parentTabChange(1)">Parent 1</button>
                            <button type="button" class="parent-pill" [class.active]="selectedParent === 2"
                                    (click)="parentTabChange(2)">Parent 2</button>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-3" *ngFor="let group of parentInfoGroups">
                                <div class="info-group-card">
                                    <div class="info-group-header">
                                        <i class="fa {{ group.icon }}"></i>
                                        <span>{{ group.title }}</span>
                                    </div>
                                    <div class="info-group-body info-group-body-grid">
                                        <div class="info-field" *ngFor="let field of group.fields">
                                            <span class="field-label">{{ field.label }}</span>
                                            <span class="field-value" [class.text-capitalize]="field.capitalize">
                                                {{ getParentFieldValue(field.key) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Class Details -->
                <div *ngIf="activeTab === 'classes'">
                    <div class="table-responsive student-profile" style="overflow-y: auto; max-height: 55vh">
                        <table class="table table-bordered">
                            <thead style="background: #cdd9f6">
                            <tr>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Class Name</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Class Code</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Subject</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Grade</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Start Date</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">End Date</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Joined Date</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Dropped Date</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Notify Parent</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="studentFullClassListData.length === 0" class="text-center">
                                <td colspan="10">
                                    <span class="color-primary">No Data Available!</span>
                                </td>
                            </tr>
                            <tr *ngFor="let classData of studentFullClassListData">
                                <td style="vertical-align: middle" class="color-primary">
                                    <span class="font-weight-bold">{{ classData.class_name }}</span>
                                </td>
                                <td style="vertical-align: middle">{{ classData.class_code }}</td>
                                <td style="vertical-align: middle">{{ classData.subject != '' ? classData.subject : '-' }}</td>
                                <td style="vertical-align: middle">{{ classData.grade != '' ? classData.grade : '-' }}</td>
                                <td style="vertical-align: middle">{{ classData.start_date | customDateFormat }}</td>
                                <td style="vertical-align: middle">{{ classData.end_date | customDateFormat }}</td>
                                <td style="vertical-align: middle">{{ classData.joining_date | customDateFormat }}</td>
                                <td style="vertical-align: middle">
                                    {{ classData.drafted_date != '0000-00-00' ? (classData.drafted_date | customDateFormat) : '-' }}
                                </td>
                                <td (click)="classData.showText = false" class="color-primary cursor" style="vertical-align: middle">
                                    <span *ngIf="classData.showText" class="font-weight-bold">
                                        {{ classData.notify_status == '0' ? 'No' : 'Yes' }}
                                    </span>
                                    <select (change)="studentNotifyStatus(classData, $event.target.value)"
                                            *ngIf="!classData.showText" class="form-control" [value]="classData.notify_status">
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                </td>
                                <td style="vertical-align: middle">
                                    <img alt="" class="mx-2 cursor" style="width:23px" src="assets/images/icons/report.png"
                                         title="Report" (click)="getStudentFullDetail(classData)">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Attendance -->
                <div *ngIf="activeTab === 'attendance'">
                    <div class="form-group col-md-4 pl-0" *ngIf="classList.length != 0">
                        <label class="font-weight-bold">Class List</label>
                        <ng-select [items]="classList"
                                   bindLabel="class_name"
                                   bindValue="class_id"
                                   placeholder="Please Select"
                                   [ngModel]="selectedClassId"
                                   (change)="attendanceFilter($event)">
                        </ng-select>
                    </div>
                    <div class="table-responsive student-profile" style="overflow-y: auto; max-height: 55vh">
                        <table class="table table-bordered">
                            <thead style="background: #cdd9f6">
                            <tr>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Class Name</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Date</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Time Slot</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Attendance</th>
                                <th style="position: sticky; top: 0; background: #cdd9f6">Make-up Class</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="attendanceListData.length === 0" class="text-center">
                                <td colspan="5">
                                    <span class="color-primary">No Data Available!</span>
                                </td>
                            </tr>
                            <tr *ngFor="let attendance of attendanceListData; let i = index">
                                <td style="vertical-align: middle" class="color-primary">
                                    <span class="font-weight-bold">{{ attendance.class_name }}</span>
                                </td>
                                <td style="vertical-align: middle">{{ attendance.date | customDateFormat }}</td>
                                <td style="vertical-align: middle">
                                    <span>{{ attendance.start_time }} - {{ attendance.end_time }}</span>
                                </td>
                                <td style="vertical-align: middle">
                                    <i style="font-size: 18px" *ngIf="attendance.attendance == '1'" class="fa fa-check-circle color-green"></i>
                                    <i style="font-size: 18px" *ngIf="attendance.attendance == '0'" class="fa fa-times-circle color-red"></i>
                                    <span *ngIf="attendance.attendance == '' && attendance.attendance">-</span>
                                </td>
                                <td style="vertical-align: middle">
                                    <button (click)="addMakeUpClass(attendance)"
                                            *ngIf="attendance?.makeup_class_id == '' && attendance?.attendance == '0'
                                            && (auth.getRoleId() == '2' || (auth.getRoleId() == '4' && auth.getSessionData('teacher_type') != '0'))"
                                            class="btn-sm-view cancel px-2 py-1" type="button">
                                        <i style="font-size: 16px" class="fa fa-calendar-plus-o mr-1" title="Schedule Make-up Class" aria-hidden="true"></i>
                                        Schedule Make-up Class
                                    </button>
                                    <label *ngIf="attendance?.makeup_class_id != '' && attendance?.attendance == '0'" class="makUpClass_text mb-0">
                                        <span style="font-size: 14px" class="ml-1 color-primary font-weight-bold">
                                            {{ attendance?.makeup_class_name }} - {{ attendance?.makeup_class_date | customDateFormat }}
                                        </span>
                                    </label>
                                    <i (click)="voidFunctionCalled(attendance, i)" title="Void Class"
                                       *ngIf="attendance?.makeup_class_id != '' && ['0', ''].indexOf(attendance.attendance) > -1 && attendance.allow_void_class"
                                       style="font-size: 18px" class="fa fa-times-circle color-red ml-2 cursor"></i>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Curriculum -->
                <div *ngIf="activeTab === 'curriculum'">
                    <div class="curriculum-toolbar">
                        <div class="curriculum-filters">
                            <div class="filter-field">
                                <label class="toolbar-label">Class</label>
                                <ng-select [items]="curriculumClassFilterOptions" bindLabel="class_name" bindValue="class_id"
                                           placeholder="All Class" [ngModel]="selectedCurriculumClassId"
                                           (change)="curriculumClassFilter($event)"></ng-select>
                            </div>
                            <div class="filter-field">
                                <label class="toolbar-label">Content Type</label>
                                <select class="form-control custom-select" [(ngModel)]="curriculumContentTypeFilter"
                                        (change)="onCurriculumContentTypeChange()">
                                    <option *ngFor="let opt of curriculumContentTypeOptions" [value]="opt.value">
                                        {{ opt.label }}
                                    </option>
                                </select>
                            </div>
                            <span class="curriculum-count">{{ curriculumListData.length }} items</span>
                        </div>
                    </div>

                    <div *ngIf="curriculumListData.length === 0" class="curriculum-empty">
                        <i class="fa fa-folder-open-o"></i>
                        <p>No curriculum items match your filters.</p>
                    </div>

                    <div class="curriculum-table-wrap" *ngIf="curriculumListData.length > 0">
                        <div class="curriculum-grid curriculum-grid-head">
                            <span class="grid-head-cell">Content</span>
                            <span class="grid-head-cell">Type</span>
                            <span class="grid-head-cell">Class</span>
                            <span class="grid-head-cell">Date range</span>
                            <span class="grid-head-cell grid-head-right">Percentage</span>
                            <span class="grid-head-cell grid-head-right">Status</span>
                            <span class="grid-head-cell grid-head-right">Action</span>
                        </div>
                        <div class="curriculum-card-list">
                            <div *ngFor="let item of curriculumPaginatedItems"
                                 class="curriculum-card curriculum-grid curriculum-grid-row"
                                 [ngClass]="item.content_type == '1' ? 'accent-resource' : item.content_type == '2' ? 'accent-assignment' : 'accent-assessment'">
                                <div class="grid-cell cell-content">
                                    <div class="content-thumb-wrap">
                                        <img [src]="curriculumThumb" alt="" class="curriculum-thumb">
                                        <span class="format-tag">{{ item.content_format }}</span>
                                    </div>
                                    <h6 class="content-title col-11" [title]="item.content_name">{{ item.content_name }}</h6>
                                </div>
                                <div class="grid-cell cell-type">
                                    <span class="type-pill" [ngClass]="contentTypeBadgeClass(item.content_type)">
                                        {{ item.content_type == '1' ? 'Resource' : item.content_type == '2' ? 'Assignment' : 'Assessment'}}
                                    </span>
                                </div>
                                <div class="grid-cell cell-class">
                                    <span class="class-name-text" [title]="item.class_name">{{ item.class_name }}</span>
                                </div>
                                <div class="grid-cell cell-dates">
                                    <i class="fa fa-calendar-o mr-1 text-muted"></i>
                                    <span>{{ item.start_date }} – {{ item.end_date }}</span>
                                </div>
                                <div class="grid-cell cell-percentage">
                                    <span class="percentage-text">{{ getCurriculumPercentage(item) }}</span>
                                </div>
                                <div class="grid-cell cell-status">
                                    <span class="type-pill" [ngClass]="curriculumStatusBadgeClass(item)">
                                        {{ curriculumStatusLabel(item) }}
                                    </span>
                                </div>
                                <div class="grid-cell cell-action">
                                    <i *ngIf="canViewCurriculumDetail(item)"
                                       style="border: 1px solid;padding: 4px;border-radius: 4px;"
                                       class="fa fa-eye color-primary cursor"
                                       title="View Content"
                                       (click)="viewReportDetail(item)"></i>
                                    <span *ngIf="!canViewCurriculumDetail(item)" class="text-muted">-</span>
                                </div>
                            </div>
                        </div>
                        <nav *ngIf="curriculumListData.length > curriculumPageSize" class="mb-2 curriculum-pagination">
                            <ul class="pagination justify-content-end mb-0">
                                <li class="page-item" [class.disabled]="curriculumCurrentPage === 1">
                                    <a class="page-link cursor" (click)="firstCurriculumPage()">«</a>
                                </li>
                                <li class="page-item" [class.disabled]="curriculumCurrentPage === 1">
                                    <a class="page-link cursor" (click)="previousCurriculumPage()"><</a>
                                </li>
                                <li class="page-item" *ngFor="let page of curriculumPages" [class.active]="curriculumCurrentPage === page">
                                    <a class="page-link cursor" (click)="setCurriculumPage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" [class.disabled]="curriculumCurrentPage === curriculumTotalPages">
                                    <a class="page-link cursor" (click)="nextCurriculumPage()">></a>
                                </li>
                                <li class="page-item" [class.disabled]="curriculumCurrentPage === curriculumTotalPages">
                                    <a class="page-link cursor" (click)="lastCurriculumPage()">»</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <!-- Communications (In-App only) -->
                <div *ngIf="activeTab === 'communications'" class="communications-panel">
                    <div class="communications-header">
                        <h5 class="communications-title">In-App Messages</h5>
                        <p class="communications-subtitle">Notifications sent to the student within EdQuill.</p>
                    </div>
                    <div class="inapp-message-list">
                        <div *ngIf="communicationsData.length === 0" class="communications-empty">
                            <i class="fa fa-bell-o"></i>
                            <p>No in-app messages available.</p>
                        </div>
                        <div *ngFor="let msg of communicationsData" class="inapp-message-card">
                            <div class="message-card-accent"></div>
                            <div class="message-card-body">
                                <div class="message-class-panel">
                                    <div class="message-icon">
                                        <i class="fa fa-bell"></i>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center flex-column mx-2" style="flex: 0 0 12%">
                                    <h6 class="message-class-label">Class Name</h6>
                                    <h6 class="message-class-date">{{ getCommunicationClassDate(msg) }}</h6>
                                </div>
                                <div class="message-divider" aria-hidden="true"></div>
                                <div class="message-main">
                                    <span class="message-posted-date">{{ msg.created_date | customDateFormat }}</span>
                                    <div class="message-content-row">
                                        <span class="content-name-label">Content Name:</span>
                                        <span class="content-name-value">{{ msg.content_name || '-' }}</span>
                                        <span class="comm-type-pill" [ngClass]="contentTypeBadgeClass(msg.content_type)">
                                            {{ communicationContentTypeLabel(msg.content_type) }}
                                        </span>
                                    </div>
                                    <p class="message-preview" [innerHTML]="msg.notes | sanitizeHtml"></p>
                                    <span class="message-sender">
                                        <i class="fa fa-user-o" aria-hidden="true"></i>
                                        {{ msg.created_by || '-' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #viewoveralldetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title color-primary" id="modal-basic-title">Assignment Details</h4>
        <i (click)="closeOverAll()" aria-hidden="true"
           class="fa fa-close fa-lg mt-1 cursor" style="color:#7F3486; float: right;"></i>
    </div>
    <div class="modal-body">
        <app-student-report [classData]="classData" [studentId]="studentId"></app-student-report>
    </div>
</ng-template>

<ng-template #viewStudentDetails let-c="close" let-d="dismiss">
    <div class="modal-header align-items-center">
        <h4 class="modal-title font-weight-bold">Correction Details</h4>
        <i class="fa fa-close cursor" (click)="closeReportDetail()"></i>
    </div>
    <div class="modal-body">
        <app-answer-sheet [answerShow]="true" [contentId]="reportContentId" [contentFormat]="reportContentFormat"
                          [is_test]="reportIsTest" [classId]="reportClassId" [studentReportId]="studentId"
                          [backStatus]="false" [studentContentId]="reportStudentContentId"></app-answer-sheet>
    </div>
</ng-template>

<ng-template #voidClass>
    <div class="modal-header align-items-center">
        <h5 class="modal-title align-items-center font-weight-bold">Void Class</h5>
        <i class="fa fa-close cursor" (click)="modalRef.close()"></i>
    </div>
    <div class="modal-body">
        <div class="col-md-12 px-0">
            <p class="mb-0"><strong>
                Are you sure want to void the<span class="color-primary ml-1">{{ voidClassData.makeup_class_name }}</span>?</strong>
            </p>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn cancel" type="button" (click)="modalRef.close()">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="deleteStudentList()">Yes</button>
    </div>
</ng-template>
